// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ops-scope {
  --ops-panel-bg: #fcfcfd;
  --ops-seg-bg: #edeef1;
  --ops-line: #e6e9ee;
  --ops-mono: ui-monospace, SFMono-Regular, Menlo, monospace;
  --ops-modal-bg: #f5f7fa;
  --ops-draft-bg: #fff3d4;
  --ops-draft-fg: #8a6a16;
  --ops-draft-border: #f0d99a;
  --ops-latest-bg: #E8EEF7;
  --ops-latest-fg: #1F3A5F;
  --ops-latest-border: #c8d4e6;
  --ops-inuse-bg: #e3f0e0;
  --ops-inuse-fg: #3f7a3a;
  --ops-inuse-border: #b9d7b4;
  --ops-error: #C8394F;
  --ops-error-bg: #FDECEF;
  --ops-error-border: #F2A7B4;
  --ops-error-text: #A32A3E;
  --ops-warn: #E0A030;
  --ops-warn-bg: #FFF6E0;
  --ops-warn-border: #F0C870;
  --ops-warn-text: #9A6A10;
  --ops-delete: #b3261e;
  --ops-delete-dark: #8c1d18;
  --ops-delete-bg: #fdf1f0;
  --ops-delete-border: #e3a8a4;
  color: var(--dark-color-dark);
}
.ops-scope .bi {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1 !important;
  vertical-align: middle;
}
.ops-scope .bi::before {
  vertical-align: 0 !important;
  display: block;
  line-height: 1;
}
.ops-scope button {
  font-family: inherit;
}
.ops-scope .ops-pill {
  height: 28px;
  min-height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  border: 1px solid var(--border-weak-color);
  background: var(--white-color-lightest);
  color: var(--dark-color-dark);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 1;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}
.ops-scope .ops-pill:hover {
  background: var(--dark-color-main);
  color: var(--white-color-main);
  border-color: var(--dark-color-main);
}
.ops-scope .ops-pill.is-small {
  height: 20px;
  min-height: 20px;
  padding: 0 7px;
  border-radius: 10px;
  color: var(--dark-color-main);
  font-size: 10.5px;
}
.ops-scope .ops-pill.is-small:hover {
  color: var(--white-color-main);
}
.ops-scope .ops-pill.is-primary {
  padding: 0 14px;
  border-color: var(--primary-color-main);
  background: var(--primary-color-main);
  color: var(--white-color-light);
  font-weight: 600;
}
.ops-scope .ops-pill.is-primary:hover {
  background: var(--primary-color-dark);
  border-color: var(--primary-color-dark);
}
.ops-scope .ops-pill[aria-disabled=true] {
  color: var(--input-placeholder-color);
  border-color: var(--ops-line);
  cursor: not-allowed;
}
.ops-scope .ops-pill[aria-disabled=true]:hover {
  background: var(--white-color-lightest);
  color: var(--input-placeholder-color);
  border-color: var(--ops-line);
}
.ops-scope .ops-footer-btn {
  min-height: 40px;
  padding: 8px 24px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 2px;
  font-size: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--dark-color-main);
}
.ops-scope .ops-footer-btn:hover {
  background: var(--dark-color-dark-transparent-10);
}
.ops-scope .ops-footer-btn.is-primary {
  min-width: 120px;
  border-color: var(--primary-color-main);
  background: var(--primary-color-main);
  color: var(--white-color-light);
}
.ops-scope .ops-footer-btn.is-primary:hover {
  background: var(--primary-color-dark);
  border-color: var(--primary-color-dark);
}
.ops-scope .ops-footer-btn.is-primary-outline {
  border-color: var(--primary-color-main);
  color: var(--primary-color-main);
}
.ops-scope .ops-footer-btn.is-primary-outline:hover {
  background: var(--primary-color-lightest);
}
.ops-scope .ops-footer-btn.is-danger {
  padding: 8px 20px;
  border-color: var(--ops-delete);
  background: var(--ops-delete);
  color: var(--white-color-lightest);
}
.ops-scope .ops-footer-btn.is-danger:hover {
  background: var(--ops-delete-dark);
  border-color: var(--ops-delete-dark);
}
.ops-scope .ops-footer-btn:disabled, .ops-scope .ops-footer-btn[aria-disabled=true] {
  pointer-events: none;
}
.ops-scope .ops-footer-btn:disabled.is-primary, .ops-scope .ops-footer-btn[aria-disabled=true].is-primary {
  background: var(--primary-color-disabled);
  border-color: var(--primary-color-disabled);
}
.ops-scope .ops-footer-btn:disabled.is-primary-outline, .ops-scope .ops-footer-btn[aria-disabled=true].is-primary-outline {
  border-color: var(--primary-color-disabled);
  color: var(--primary-color-disabled);
}
.ops-scope .ops-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 9.5px;
  font-weight: 700;
  line-height: 15px;
  flex-shrink: 0;
  white-space: nowrap;
  border: 1px solid transparent;
}
.ops-scope .ops-badge.is-deployed, .ops-scope .ops-badge.is-required {
  background: var(--primary-color-lightest);
  color: var(--primary-color-main);
  border-color: var(--primary-color-main);
}
.ops-scope .ops-badge.is-latest {
  background: var(--ops-latest-bg);
  color: var(--ops-latest-fg);
  border-color: var(--ops-latest-border);
}
.ops-scope .ops-badge.is-draft {
  background: var(--ops-draft-bg);
  color: var(--ops-draft-fg);
  border-color: var(--ops-draft-border);
}
.ops-scope .ops-badge.is-optional {
  background: #f4f5f7;
  color: var(--dark-color-main);
  border-color: var(--ops-line);
}
.ops-scope .ops-badge.is-inuse {
  padding: 1px 8px;
  font-size: 10.5px;
  line-height: 16px;
  background: var(--ops-inuse-bg);
  color: var(--ops-inuse-fg);
  border-color: var(--ops-inuse-border);
}
.ops-scope .ops-badge.is-inuse::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--ops-inuse-fg);
}
.ops-scope .ops-dirty-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--warning-color-main);
  flex-shrink: 0;
}
.ops-scope .ops-input, .ops-scope .ops-select, .ops-scope .ops-textarea {
  display: block;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  color: var(--dark-color-dark);
  background: var(--input-bg-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 14px;
  outline: 0;
}
.ops-scope .ops-input:focus, .ops-scope .ops-select:focus, .ops-scope .ops-textarea:focus {
  border-color: var(--primary-color-main);
}
.ops-scope .ops-select {
  cursor: pointer;
}
.ops-scope .ops-textarea {
  height: auto;
  min-height: 76px;
  padding: 12px;
  line-height: 1.6;
  resize: vertical;
}
.ops-scope .ops-field-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--dark-color-main);
}
.ops-scope .ops-field-label .ops-required {
  color: var(--primary-color-main);
  font-size: 11px;
  font-weight: 600;
}
.ops-scope .ops-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ops-scope .ops-section-title .ops-section-title-label {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
  white-space: nowrap;
}
.ops-scope .ops-section-title .ops-section-title-note {
  font-size: 11px;
  color: var(--font_active_sub_color);
  white-space: nowrap;
}
.ops-scope .ops-section-title::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: var(--ops-line);
}
.ops-scope .ops-warn-text {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--ops-draft-fg);
}
.ops-scope .ops-error-text {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #c8394f;
}
.ops-scope .ops-footer-spacer {
  flex: 1 1;
}
.ops-scope .ops-delete-button {
  min-height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid var(--ops-delete-border);
  background: transparent;
  color: var(--ops-delete);
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ops-scope .ops-delete-button .bi {
  font-size: 16px;
}
.ops-scope .ops-delete-button:hover {
  background: var(--ops-delete-bg);
}
.ops-scope .ops-delete-button[aria-disabled=true] {
  border-color: var(--ops-line);
  color: var(--input-placeholder-color);
  cursor: not-allowed;
}
.ops-scope .ops-delete-button[aria-disabled=true]:hover {
  background: transparent;
}
.ops-scope .ops-delete-note {
  font-size: 11px;
  color: var(--disabled-font-color);
}
.ops-scope .ops-dialog-footer.is-delete-confirm {
  background: var(--ops-delete-bg);
}
.ops-scope .ops-delete-confirm {
  flex: 1 1;
  min-width: 240px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--ops-delete);
}
.ops-scope .ops-delete-confirm .bi {
  font-size: 18px;
  flex-shrink: 0;
}
.ops-scope .ops-delete-confirm-title {
  font-size: 14px;
  font-weight: 700;
}
.ops-scope .ops-delete-confirm-note {
  font-size: 12px;
  color: var(--dark-color-main);
}
.ops-scope .ops-delete-cancel {
  padding: 8px 20px;
  background: var(--white-color-lightest);
}
.ops-scope .ops-delete-cancel:hover {
  background: #f1f2f4;
}
.ops-scope .ops-setting-card {
  background: var(--white-color-lightest);
  border-radius: 8px;
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.ops-scope .ops-setting-card hr {
  margin: 0;
}
.ops-scope .ops-setting-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}
.ops-scope .ops-setting-label {
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  text-align: left;
}
.ops-scope .ops-setting-label .ops-setting-label-text {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
}
.ops-scope .ops-setting-label .ops-setting-label-hint {
  font-size: 12px;
  color: var(--font_active_sub_color);
  white-space: pre-line;
}
.ops-scope .ops-setting-field {
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  text-align: left;
}
.ops-scope .ops-setting-sub {
  font-size: 12px;
  color: var(--font_active_hidden_color);
}
.ops-scope .ops-setting-error {
  font-size: 12px;
  font-weight: 600;
  color: var(--ops-error);
}
.ops-scope .ops-domain-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ops-scope .ops-domain-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ops-scope .ops-domain-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.ops-scope .ops-domain-input {
  width: 360px;
  max-width: 100%;
}
.ops-scope .ops-domain-input.is-error .textinput {
  border-color: var(--ops-error);
}
.ops-scope .ops-domain-remove {
  width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  color: var(--dark-color-main);
  transition: background-color 0.2s;
}
.ops-scope .ops-domain-remove:hover {
  background-color: var(--dark-color-dark-transparent-10);
  color: var(--danger-color-main);
}
.ops-scope .ops-domain-add {
  width: auto;
  min-height: 32px;
  padding: 4px 12px 4px 8px;
  background-color: transparent;
  border: none;
  color: var(--primary-color-main);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  transition: background-color 0.2s;
}
.ops-scope .ops-domain-add .button-label {
  gap: 4px;
}
.ops-scope .ops-domain-add:hover {
  background-color: var(--primary-color-main-transparent-25);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/ops/OpsCommon.scss"],"names":[],"mappings":"AACA;EAEI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,0DAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;EACA,wBAAA;EACA,4BAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,oBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,wBAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;EACA,4BAAA;EAEA,6BAAA;AAFJ;AAKI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;AAHR;AAKQ;EACI,4BAAA;EACA,cAAA;EACA,cAAA;AAHZ;AAOI;EACI,oBAAA;AALR;AASI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,uCAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAPR;AASQ;EACI,kCAAA;EACA,8BAAA;EACA,oCAAA;AAPZ;AAUQ;EACI,YAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;AARZ;AAWY;EACI,8BAAA;AAThB;AAaQ;EACI,eAAA;EACA,uCAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;AAXZ;AAaY;EACI,qCAAA;EACA,uCAAA;AAXhB;AAeQ;EACI,qCAAA;EACA,6BAAA;EACA,mBAAA;AAbZ;AAeY;EACI,uCAAA;EACA,qCAAA;EACA,6BAAA;AAbhB;AAmBI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qCAAA;EACA,uBAAA;EACA,6BAAA;AAjBR;AAmBQ;EACI,iDAAA;AAjBZ;AAoBQ;EACI,gBAAA;EACA,uCAAA;EACA,qCAAA;EACA,+BAAA;AAlBZ;AAoBY;EACI,qCAAA;EACA,uCAAA;AAlBhB;AAuBQ;EACI,uCAAA;EACA,gCAAA;AArBZ;AAuBY;EAAU,yCAAA;AApBtB;AAuBQ;EACI,iBAAA;EACA,+BAAA;EACA,6BAAA;EACA,kCAAA;AArBZ;AAuBY;EACI,kCAAA;EACA,oCAAA;AArBhB;AAyBQ;EACI,oBAAA;AAvBZ;AAyBY;EACI,yCAAA;EACA,2CAAA;AAvBhB;AAyBY;EACI,2CAAA;EACA,oCAAA;AAvBhB;AA6BI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;AA3BR;AA6BQ;EACI,yCAAA;EACA,gCAAA;EACA,uCAAA;AA3BZ;AA6BQ;EACI,gCAAA;EACA,2BAAA;EACA,sCAAA;AA3BZ;AA6BQ;EACI,+BAAA;EACA,0BAAA;EACA,qCAAA;AA3BZ;AA6BQ;EACI,mBAAA;EACA,6BAAA;EACA,6BAAA;AA3BZ;AA6BQ;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,+BAAA;EACA,0BAAA;EACA,qCAAA;AA3BZ;AA6BY;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;AA3BhB;AAiCI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;AA/BR;AAmCI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,iCAAA;EACA,qCAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;AAjCR;AAmCQ;EACI,uCAAA;AAjCZ;AAqCI;EACI,eAAA;AAnCR;AAsCI;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AApCR;AAuCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,6BAAA;AArCR;AAuCQ;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;AArCZ;AA0CI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAxCR;AA0CQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAxCZ;AA0CQ;EACI,eAAA;EACA,mCAAA;EACA,mBAAA;AAxCZ;AA0CQ;EACI,WAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;AAxCZ;AA4CI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AA1CR;AA6CI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA3CR;AA8CI;EACI,SAAA;AA5CR;AAgDI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,uBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA9CR;AAgDQ;EAAM,eAAA;AA7Cd;AA+CQ;EAAU,gCAAA;AA5ClB;AA8CQ;EACI,6BAAA;EACA,qCAAA;EACA,mBAAA;AA5CZ;AA8CY;EAAU,uBAAA;AA3CtB;AA+CI;EACI,eAAA;EACA,iCAAA;AA7CR;AAgDI;EACI,gCAAA;AA9CR;AAiDI;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;AA/CR;AAiDQ;EAAM,eAAA;EAAiB,cAAA;AA7C/B;AAgDI;EACI,eAAA;EACA,gBAAA;AA9CR;AAiDI;EACI,eAAA;EACA,6BAAA;AA/CR;AAkDI;EACI,iBAAA;EACA,uCAAA;AAhDR;AAkDQ;EAAU,mBAAA;AA/ClB;AAmDI;EACI,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjDR;AAmDQ;EACI,SAAA;AAjDZ;AAqDI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AAnDR;AAsDI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AApDR;AAsDQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AApDZ;AAuDQ;EACI,eAAA;EACA,mCAAA;EACA,qBAAA;AArDZ;AAyDI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAvDR;AA0DI;EACI,eAAA;EACA,sCAAA;AAxDR;AA2DI;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;AAzDR;AA6DI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA3DR;AA8DI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AA5DR;AA+DI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AA7DR;AAgEI;EACI,YAAA;EACA,eAAA;AA9DR;AAgEQ;EACI,8BAAA;AA9DZ;AAkEI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,6BAAA;EACA,iCAAA;AAhER;AAkEQ;EACI,uDAAA;EACA,+BAAA;AAhEZ;AAoEI;EACI,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AAlER;AAoEQ;EACI,QAAA;AAlEZ;AAqEQ;EACI,0DAAA;AAnEZ","sourcesContent":["// 運営ツール共通の部品（デザイン PRizmo_Admin.dc.html の運営ツール画面に合わせる）\n.ops-scope {\n    // 既存の変数に無い固定色（運営ツールの中だけで使う）\n    --ops-panel-bg: #fcfcfd;\n    --ops-seg-bg: #edeef1;\n    --ops-line: #e6e9ee;\n    --ops-mono: ui-monospace, SFMono-Regular, Menlo, monospace;\n    --ops-modal-bg: #f5f7fa;\n    --ops-draft-bg: #fff3d4;\n    --ops-draft-fg: #8a6a16;\n    --ops-draft-border: #f0d99a;\n    --ops-latest-bg: #E8EEF7;\n    --ops-latest-fg: #1F3A5F;\n    --ops-latest-border: #c8d4e6;\n    --ops-inuse-bg: #e3f0e0;\n    --ops-inuse-fg: #3f7a3a;\n    --ops-inuse-border: #b9d7b4;\n    --ops-error: #C8394F;\n    --ops-error-bg: #FDECEF;\n    --ops-error-border: #F2A7B4;\n    --ops-error-text: #A32A3E;\n    --ops-warn: #E0A030;\n    --ops-warn-bg: #FFF6E0;\n    --ops-warn-border: #F0C870;\n    --ops-warn-text: #9A6A10;\n    --ops-delete: #b3261e;\n    --ops-delete-dark: #8c1d18;\n    --ops-delete-bg: #fdf1f0;\n    --ops-delete-border: #e3a8a4;\n\n    color: var(--dark-color-dark);\n\n    // Bootstrap Icons の既定の vertical-align を打ち消し、1em 四方の箱の中央にグリフを置く\n    .bi {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        line-height: 1 !important;\n        vertical-align: middle;\n\n        &::before {\n            vertical-align: 0 !important;\n            display: block;\n            line-height: 1;\n        }\n    }\n\n    button {\n        font-family: inherit;\n    }\n\n    // ピル型ボタン（28px）\n    .ops-pill {\n        height: 28px;\n        min-height: 28px;\n        padding: 0 12px;\n        border-radius: 14px;\n        border: 1px solid var(--border-weak-color);\n        background: var(--white-color-lightest);\n        color: var(--dark-color-dark);\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        line-height: 1;\n        font-size: 12px;\n        white-space: nowrap;\n        flex-shrink: 0;\n\n        &:hover {\n            background: var(--dark-color-main);\n            color: var(--white-color-main);\n            border-color: var(--dark-color-main);\n        }\n\n        &.is-small {\n            height: 20px;\n            min-height: 20px;\n            padding: 0 7px;\n            border-radius: 10px;\n            color: var(--dark-color-main);\n            font-size: 10.5px;\n\n            // 上の :hover より後で文字色を上書きしているため、ホバー時の白文字をここでも指定する\n            &:hover {\n                color: var(--white-color-main);\n            }\n        }\n\n        &.is-primary {\n            padding: 0 14px;\n            border-color: var(--primary-color-main);\n            background: var(--primary-color-main);\n            color: var(--white-color-light);\n            font-weight: 600;\n\n            &:hover {\n                background: var(--primary-color-dark);\n                border-color: var(--primary-color-dark);\n            }\n        }\n\n        &[aria-disabled=\"true\"] {\n            color: var(--input-placeholder-color);\n            border-color: var(--ops-line);\n            cursor: not-allowed;\n\n            &:hover {\n                background: var(--white-color-lightest);\n                color: var(--input-placeholder-color);\n                border-color: var(--ops-line);\n            }\n        }\n    }\n\n    // フッターのボタン（40px）\n    .ops-footer-btn {\n        min-height: 40px;\n        padding: 8px 24px;\n        border-radius: 8px;\n        font-weight: 600;\n        letter-spacing: 2px;\n        font-size: 16px;\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        border: 1px solid var(--border-color);\n        background: transparent;\n        color: var(--dark-color-main);\n\n        &:hover {\n            background: var(--dark-color-dark-transparent-10);\n        }\n\n        &.is-primary {\n            min-width: 120px;\n            border-color: var(--primary-color-main);\n            background: var(--primary-color-main);\n            color: var(--white-color-light);\n\n            &:hover {\n                background: var(--primary-color-dark);\n                border-color: var(--primary-color-dark);\n            }\n        }\n\n        // primary の隣に置く副アクション\n        &.is-primary-outline {\n            border-color: var(--primary-color-main);\n            color: var(--primary-color-main);\n\n            &:hover { background: var(--primary-color-lightest); }\n        }\n\n        &.is-danger {\n            padding: 8px 20px;\n            border-color: var(--ops-delete);\n            background: var(--ops-delete);\n            color: var(--white-color-lightest);\n\n            &:hover {\n                background: var(--ops-delete-dark);\n                border-color: var(--ops-delete-dark);\n            }\n        }\n\n        &:disabled, &[aria-disabled=\"true\"] {\n            pointer-events: none;\n\n            &.is-primary {\n                background: var(--primary-color-disabled);\n                border-color: var(--primary-color-disabled);\n            }\n            &.is-primary-outline {\n                border-color: var(--primary-color-disabled);\n                color: var(--primary-color-disabled);\n            }\n        }\n    }\n\n    // 丸いバッジ\n    .ops-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        padding: 0 6px;\n        border-radius: 999px;\n        font-size: 9.5px;\n        font-weight: 700;\n        line-height: 15px;\n        flex-shrink: 0;\n        white-space: nowrap;\n        border: 1px solid transparent;\n\n        &.is-deployed, &.is-required {\n            background: var(--primary-color-lightest);\n            color: var(--primary-color-main);\n            border-color: var(--primary-color-main);\n        }\n        &.is-latest {\n            background: var(--ops-latest-bg);\n            color: var(--ops-latest-fg);\n            border-color: var(--ops-latest-border);\n        }\n        &.is-draft {\n            background: var(--ops-draft-bg);\n            color: var(--ops-draft-fg);\n            border-color: var(--ops-draft-border);\n        }\n        &.is-optional {\n            background: #f4f5f7;\n            color: var(--dark-color-main);\n            border-color: var(--ops-line);\n        }\n        &.is-inuse {\n            padding: 1px 8px;\n            font-size: 10.5px;\n            line-height: 16px;\n            background: var(--ops-inuse-bg);\n            color: var(--ops-inuse-fg);\n            border-color: var(--ops-inuse-border);\n\n            &::before {\n                content: \"\";\n                width: 5px;\n                height: 5px;\n                border-radius: 50%;\n                background: var(--ops-inuse-fg);\n            }\n        }\n    }\n\n    // 未保存を示すオレンジの点\n    .ops-dirty-dot {\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        background: var(--warning-color-main);\n        flex-shrink: 0;\n    }\n\n    // 入力欄\n    .ops-input, .ops-select, .ops-textarea {\n        display: block;\n        width: 100%;\n        height: 40px;\n        padding: 0 12px;\n        color: var(--dark-color-dark);\n        background: var(--input-bg-color);\n        border: 1px solid var(--border-color);\n        border-radius: 4px;\n        box-sizing: border-box;\n        font-family: inherit;\n        font-size: 14px;\n        outline: 0;\n\n        &:focus {\n            border-color: var(--primary-color-main);\n        }\n    }\n\n    .ops-select {\n        cursor: pointer;\n    }\n\n    .ops-textarea {\n        height: auto;\n        min-height: 76px;\n        padding: 12px;\n        line-height: 1.6;\n        resize: vertical;\n    }\n\n    .ops-field-label {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        font-size: 12px;\n        color: var(--dark-color-main);\n\n        .ops-required {\n            color: var(--primary-color-main);\n            font-size: 11px;\n            font-weight: 600;\n        }\n    }\n\n    // 区切り見出し（キャラクター動画 ─────）\n    .ops-section-title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .ops-section-title-label {\n            font-size: 12px;\n            font-weight: 800;\n            letter-spacing: 1px;\n            white-space: nowrap;\n        }\n        .ops-section-title-note {\n            font-size: 11px;\n            color: var(--font_active_sub_color);\n            white-space: nowrap;\n        }\n        &::after {\n            content: \"\";\n            flex: 1;\n            height: 1px;\n            background: var(--ops-line);\n        }\n    }\n\n    .ops-warn-text {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 11px;\n        font-weight: 600;\n        color: var(--ops-draft-fg);\n    }\n\n    .ops-error-text {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 11px;\n        font-weight: 600;\n        color: #c8394f;\n    }\n\n    .ops-footer-spacer {\n        flex: 1;\n    }\n\n    // ダイアログのフッターで確認する削除（外見動画・デモページの編集）\n    .ops-delete-button {\n        min-height: 40px;\n        padding: 8px 16px;\n        border-radius: 8px;\n        border: 1px solid var(--ops-delete-border);\n        background: transparent;\n        color: var(--ops-delete);\n        font-weight: 600;\n        letter-spacing: 1px;\n        font-size: 14px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n\n        .bi { font-size: 16px; }\n\n        &:hover { background: var(--ops-delete-bg); }\n\n        &[aria-disabled=\"true\"] {\n            border-color: var(--ops-line);\n            color: var(--input-placeholder-color);\n            cursor: not-allowed;\n\n            &:hover { background: transparent; }\n        }\n    }\n\n    .ops-delete-note {\n        font-size: 11px;\n        color: var(--disabled-font-color);\n    }\n\n    .ops-dialog-footer.is-delete-confirm {\n        background: var(--ops-delete-bg);\n    }\n\n    .ops-delete-confirm {\n        flex: 1;\n        min-width: 240px;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        color: var(--ops-delete);\n\n        .bi { font-size: 18px; flex-shrink: 0; }\n    }\n\n    .ops-delete-confirm-title {\n        font-size: 14px;\n        font-weight: 700;\n    }\n\n    .ops-delete-confirm-note {\n        font-size: 12px;\n        color: var(--dark-color-main);\n    }\n\n    .ops-delete-cancel {\n        padding: 8px 20px;\n        background: var(--white-color-lightest);\n\n        &:hover { background: #f1f2f4; }\n    }\n\n    // 設定フォーム（ラベル 30% / 入力 70% の行を並べたカード。利用設定・テナント作成）\n    .ops-setting-card {\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        padding: 40px;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        gap: 32px;\n\n        hr {\n            margin: 0;\n        }\n    }\n\n    .ops-setting-row {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        gap: 16px;\n        width: 100%;\n    }\n\n    .ops-setting-label {\n        width: 30%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 4px;\n        text-align: left;\n\n        .ops-setting-label-text {\n            font-size: 18px;\n            font-weight: 800;\n            letter-spacing: 1px;\n        }\n\n        .ops-setting-label-hint {\n            font-size: 12px;\n            color: var(--font_active_sub_color);\n            white-space: pre-line;\n        }\n    }\n\n    .ops-setting-field {\n        width: 70%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 6px;\n        text-align: left;\n    }\n\n    .ops-setting-sub {\n        font-size: 12px;\n        color: var(--font_active_hidden_color);\n    }\n\n    .ops-setting-error {\n        font-size: 12px;\n        font-weight: 600;\n        color: var(--ops-error);\n    }\n\n    // 許可ドメイン（1行1ドメイン。追加・削除ボタンは有人引き継ぎ設定と同じ見た目）\n    .ops-domain-list {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .ops-domain-item {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n    }\n\n    .ops-domain-row {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 8px;\n    }\n\n    .ops-domain-input {\n        width: 360px;\n        max-width: 100%;\n\n        &.is-error .textinput {\n            border-color: var(--ops-error);\n        }\n    }\n\n    .ops-domain-remove {\n        width: 32px;\n        height: 32px;\n        min-height: 32px;\n        padding: 0;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: transparent;\n        border: none;\n        color: var(--dark-color-main);\n        transition: background-color 0.2s;\n\n        &:hover {\n            background-color: var(--dark-color-dark-transparent-10);\n            color: var(--danger-color-main);\n        }\n    }\n\n    .ops-domain-add {\n        width: auto;\n        min-height: 32px;\n        padding: 4px 12px 4px 8px;\n        background-color: transparent;\n        border: none;\n        color: var(--primary-color-main);\n        font-size: 14px;\n        font-weight: 700;\n        letter-spacing: 1px;\n        transition: background-color 0.2s;\n\n        .button-label {\n            gap: 4px;\n        }\n\n        &:hover {\n            background-color: var(--primary-color-main-transparent-25);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
